export default __webpack_public_path__ + "assets/svg/more_vert.f2acbf2e67be865530c8abb96d9284b0.svg";